import React from "react";
import { connect } from "react-redux";
import ServerSideDataTable from "../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { useEffect, useState, useRef } from "react";
import { isPermittedPage } from "../../apis/Utility";
import {
  Container,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Modal,
  Image,
} from "react-bootstrap";
import { VzPageContainer } from "../../layouts/VzPageContainer";
import Moment from "react-moment";
import FormikControl from "../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import {
  GetVFOVisitListForm,
  RemoveVFOVisitListDetail,
  downloadJob,
} from "./VFOVisitListActions";
const VFOVisitList = (props) => {
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [show, setShow] = useState();
  const [target, setTarget] = useState();

  const ref = useRef(null);

  const [filter, setfilter] = useState({
    vfoName: null,
    shopCode: null,
    vizId: "",
    startDate: new Date(),
    endDate: new Date(),
    pageSize: 0,
    searchText: null,
  });
  const filterRequest = () => {
    let requestData = {
      vfoName: filter.vfoName,
      vizId: filter.vizId,
      shopCode: filter.shopCode,
      startDate: filter.startDate,
      endDate: filter.endDate,
      pageSize: currentPageSize,
      searchText: searchText,
      pageNo: currentPageNo,
    };
    return requestData;
  };

  const LoadDataByfilter = () => {
    setShow(false);
    setTarget(null);
    props.GetVFOVisitListForm(filterRequest());
  };
  const View = () => {};

  useEffect(() => {
    props.RemoveVFOVisitListDetail();
    props.GetVFOVisitListForm(filterRequest());
  }, [searchText]);

  const columns = [
    {
      Header: "Date",
      accessor: "visitDate",
      Cell: (row) => (
        <div style={{ width: "75px" }}>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
    {
      Header: "VFO Name",
      accessor: "vfoName",
    },
    {
      Header: "Total Visited",
      accessor: "totalVisited",
    },
    {
      Header: "Approved",
      accessor: "approved",
    },
    {
      Header: "Pending",
      accessor: "pending",
    },
    {
      Header: "Rejected",
      accessor: "rejected",
    },
    {
      Header: "Action",
      id: "edit",
      accessor: "id",
      Cell: ({ row: { original } }) => (
        <div style={{ width: "106px" }}>
          <Link
            className="btn btn-sm"
            to={{
              pathname: `/VFODailyVistSummaries/${original.vfoId}/${original.visitDate}`,
            }}
            aria-label="View"
          >
            <i className="fas fa-eye"></i>
          </Link>
        </div>
      ),
    },
  ];
  const Download = () => {
    let request = filterRequest();
    request.isExport = true;
    props.downloadJob(request);
    //let request = formRequestObject(true);
  };
  const getData = (page) => {
    setCurrentPageNo(page);
    let filter = filterRequest();
    filter.pageNo = page;
    props.GetVFOVisitListForm(filter);
  };

  const pageSizeChanged = (size) => {
    setCurrentPageNo(0);
    setCurrentPageSize(size);
    let filter = filterRequest();
    filter.pageNo = 0;
    filter.pageSize = size;
    props.GetVFOVisitListForm(filter);
  };
  const searchChanged = (textsearch) => {
    let filter = filterRequest();
    filter.searchText = textsearch;
    filter.pageNo = 0;
    setCurrentPageNo(0);
    setSearchText(textsearch);
    props.GetVFOVisitListForm(filter);
  };
  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setCurrentPageNo(0);
    setfilter({
      vfoName: "",
      shopCode: "",
      vizId: "",
      startDate: new Date(),
      endDate: new Date(),
      pageSize: 0,
    });
    setCurrentIndex(0);
    //setCurrentPageSize(5);
  };

  return (
    <div>
      <VzPageContainer title="VFO Module > VFO Visit List">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>VFO Visit List</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="VFO"
                                name="vfo"
                                handleOnChange={(e) => {
                                  filter.vfoName = e;
                                  setfilter({ ...filter, vfoName: e });
                                }}
                                value={filter.vfoName}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="VIZ ID"
                                name="vizId"
                                handleOnChange={(e) => {
                                  filter.vizId = e;
                                  setfilter({ ...filter, vizId: e });
                                }}
                                value={filter.vizId}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Shop Code"
                                name="shopcode"
                                handleOnChange={(e) => {
                                  filter.shopCode = e;
                                  setfilter({ ...filter, shopCode: e });
                                }}
                                value={filter.shopCode}
                              />
                            </Col>
                            <Row style={{ paddingRight: 0 }}>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  type="fromDate"
                                  control="date"
                                  label="From Date"
                                  name="fromDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, startDate: value });
                                  }}
                                  value={filter.startDate}
                                />
                              </Col>
                              <Col xs={12} md={6}>
                                <FormikControl
                                  formik={formik}
                                  control="date"
                                  type="toDate"
                                  label="To Date"
                                  name="toDate"
                                  handleOnChange={(value) => {
                                    setfilter({ ...filter, endDate: value });
                                  }}
                                  value={filter.endDate}
                                />
                              </Col>
                            </Row>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          {isPermittedPage("Export", props.actions, props.userRole) && (
            <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={Download}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.VFOVisitList ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={props.TotalRows ?? 0}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    VFOVisitList: state.VFOVisitList
      ? state.VFOVisitList.VFOVisitList?.records
      : [],
    TotalRows: state.VFOVisitList
      ? state.VFOVisitList.VFOVisitList?.totalRow
      : 0,
    VFOVisitDetailList: [],
  };
};
export default connect(mapStateToProps, {
  GetVFOVisitListForm,
  RemoveVFOVisitListDetail,
  downloadJob,
})(VFOVisitList);
